import { render, staticRenderFns } from "./stepper-navigation.html?vue&type=template&id=70d56406&scoped=true&"
import script from "./stepper-navigation.js?vue&type=script&lang=js&"
export * from "./stepper-navigation.js?vue&type=script&lang=js&"
import style0 from "./stepper-navigation.scss?vue&type=style&index=0&id=70d56406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d56406",
  null
  
)

export default component.exports